export default __webpack_public_path__ + "maps-guides-styles-layers-fill-extrusion-layer-1200-d14f5005b3571fcaeb08e8b0c4a34134.webp";